<div class="px-3 py-3">
  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 self-align-center">
      <mat-card class="shadow">
        <h3 class="content-label-each">{{ 'pages.placeholders.CreateFestival' | translate }}</h3>
        <form [formGroup]="createFestivalForm" (ngSubmit)="onSubmit()">
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label">
                {{'pages.placeholders.FestivalName' | translate }} <span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    placeholder="Enter Festival Name"
                    formControlName="occassionName"
                    required
                  />
                </mat-form-field>
                
              </div>
            </div>
          </div>
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.placeholders.Country <span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-select
                    placeholder="{{ 'pages.placeholders.Country' | translate }}"
                    formControlName="country"
                  >
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country.countryName"
                    >
                      {{ country.countryName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                
              </div>
            </div>
          </div>
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label">{{'pages.PromotionCarrierPromotions.Startdate' | translate }} <span class="required">*</span></h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [matDatepicker]="picker"
                    formControlName="occationStartdttm"
                    placeholder="MM/DD/YYYY"
                    [min]="minDate"
                  />
                  <!-- <span matPrefix>{{'pages.Creditlinereport.From' | translate }}</span> -->
                  <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon matDatepickerToggleIcon
                      >keyboard_arrow_down</mat-icon
                    >
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row g-0 mt-2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <h4 class="form-item-label">{{'pages.PromotionCarrierPromotions.Enddate' | translate }} <span class="required">*</span></h4>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                <div class="form-item-input">
                    <mat-form-field appearance="outline" class="w-100">
                      <input
                        matInput
                        [matDatepicker]="picker1"
                        formControlName="occassionEnddttm"
                        placeholder="MM/DD/YYYY"
                        [min]="
                        createFestivalForm.controls['occationStartdttm'].value
                        "
                      />
                      <mat-datepicker-toggle matSuffix [for]="picker1">
                        <mat-icon matDatepickerToggleIcon
                          >keyboard_arrow_down</mat-icon
                        >
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
            </div>
          </div>

          <div class="form-footer mt-6">
            <ul class="list-inline text-center">
              <li class="list-inline-item">
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  [disabled]="!createFestivalForm.valid"
                  class="rounded-0"
                >
                  <span translate class="translate">Create</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  class="rounded-0"
                  (click)="onCancel()"
                >
                  <span translate class="translate"
                    >pages.newRetailer.cancel</span
                  >
                </button>
              </li>
            </ul>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
</div>
